import React from "react";
import { object } from "prop-types";

import LeftImageRightNews from "../../../../../molecules/LeftImageRightNews";
import DfpContainer from "../../../../../ads/dfp-container";
import { DfpComponent } from "../../../../../ads/dfp-component";
import WidgetPlaceholder from "../../../WidgetPlaceholder";

import { getSlotId, getStoriesFromCollection, trim } from "../../../../../utils/utils";
import { useDeviceType } from "../../../../../utils/react-utils";

import "./right-column.m.css";

const RightColumn = ({ collection }) => {
  let {
    "associated-metadata": { widget_100_url: widget100Url, widget_250_url: widget250Url, ad_slot_1: adSlot1 } = {},
  } = collection;
  const items = getStoriesFromCollection(collection, 20);

  widget100Url = trim(widget100Url);
  widget250Url = trim(widget250Url);

  const widget = (() => {
    if (widget100Url) {
      return { height: 100, url: widget100Url, size: "small" };
    } else if (widget250Url) {
      return { height: 250, url: widget250Url, size: "big" };
    } else return null;
  })();

  const { desktop } = useDeviceType();
  const stories = items.slice(6, 9);

  const showExcerpt = (index) => {
    if (!widget) return true;
    else return !(widget?.size === "big" || (widget?.size === "small" && index === 2));
  };

  return (
    <div styleName="base">
      <div styleName="container">
        <DfpContainer styleName="r1-ad">
          {desktop && (
            <DfpComponent
              type={adSlot1}
              collectionSlug={collection.slug}
              slotId={getSlotId(adSlot1, collection.slug, 0, 10)}
              layoutName="FourteenStories3Ad1Widget"
            />
          )}
        </DfpContainer>
        {stories.map((story, index) => (
          <LeftImageRightNews
            styleName="right-item"
            story={story}
            key={index}
            showExcerpt={index === 0 || showExcerpt(index)}
            widths={[180]}
          />
        ))}
        {widget && <WidgetPlaceholder styleName="banner" url={widget?.url} height={widget?.height} />}
      </div>
    </div>
  );
};

RightColumn.propTypes = {
  collection: object,
};

export default RightColumn;
